import { Button, IconInfo, IconRefresh, Text } from "@sentricmusic/ui";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FormError from "@/components/FormError";

import type { GigClaimFormValues } from "../utils/gigsClaimSchema";

type GigsClaimActionsProps = {
  isUpdate: boolean;
  adminRights: boolean;
  pending: boolean;
  mutationErrorMessage: string | undefined;
  onAdd: () => void;
  onUpdate: () => void;
  onDelete: () => void;
};

function GigsClaimActions({
  isUpdate,
  adminRights,
  pending,
  mutationErrorMessage,
  onAdd,
  onUpdate,
  onDelete,
}: GigsClaimActionsProps) {
  const { t } = useTranslation("gigs");
  const str = (s: string | null): string => s ?? "";
  const { formState } = useFormContext<GigClaimFormValues>();

  return (
    <>
      <FormError mutationError={mutationErrorMessage} validationError={formState.errors.root?.message} />
      <div
        className={`flex flex-row gap-2 ${isUpdate ? "justify-between flex-row items-center xs:flex-row" : "justify-end"}`}
        id="gigsClaimButtons"
      >

        {!adminRights && (
          <span className="flex items-center gap-1 text-sm text-gray-400">
            <IconInfo className="h-4 w-4" />
            <Text as="p" className="text-sm text-gray-400">
              {t("gigs:admin-rights-required", "Admin rights required")}
            </Text>
          </span>
        )}
        {isUpdate && (
          <Button
            id="btnGigClaimDelete"
            variant="primary"
            label={str(t("gigs:delete-claim-button", "Delete Claim"))}
            onClick={onDelete}
            disabled={!adminRights || pending}
            icon={pending ? <IconRefresh className="animate-spin" /> : undefined}
          />
        )}
        <Button
          id={isUpdate ? "btnGigClaimUpdate" : "btnGigClaimAdd"}
          variant="secondary"
          label={str(isUpdate
            ? t("gigs:update-claim-button", "Update Claim")
            : t("gigs:add-claim-button", "Add Claim"))}
          onClick={isUpdate ? onUpdate : onAdd}
          disabled={!adminRights || pending}
          icon={pending ? <IconRefresh className="animate-spin" /> : undefined}
        />

      </div>
    </>
  );
}

export default GigsClaimActions;
